import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
	bankAccountsApi,
	type UpsertBankAccountInput,
} from "@/lib/payments/bank-accounts-api";

const KEY = ["payments", "bank-accounts"] as const;

export const useBankAccounts = () =>
	useQuery({ queryKey: KEY, queryFn: () => bankAccountsApi.list(), staleTime: 30_000 });

export const useCreateBankAccount = () => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (body: UpsertBankAccountInput) => bankAccountsApi.create(body),
		onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
	});
};

export const useUpdateBankAccount = () => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpsertBankAccountInput }) =>
			bankAccountsApi.update(id, body),
		onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
	});
};

export const useDeleteBankAccount = () => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => bankAccountsApi.remove(id),
		onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
	});
};
